import { Injectable } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QueryParamService {

  constructor(
    private route: ActivatedRoute,
  ) { }

  lowercaseQueryParamKeys(): Observable<Params> {
    return this.route.queryParams
      .pipe(
        switchMap((params: Params) => {
          const lowerParams: Params = {};

          for (const key in params) {
            lowerParams[key.toLocaleLowerCase()] = params[key];
          }

          return of(lowerParams); 
        })
      );
  }
}
